import Alpine from "alpinejs";
import "./directives/email-sig";

window.Alpine = Alpine;
Alpine.start();
